import { useEffect } from 'react'
import * as PIXI from 'pixi.js'
import { Live2DModel } from 'pixi-live2d-display';

window.PIXI = PIXI

Live2DModel.registerTicker(PIXI.Ticker)

function Live2DAvatarStandard(props) {
  useEffect(() => {
   // let elHeight = document.getElementById('avatar').clientHeight;
   let div = document.getElementById('avatar');
    let elWidth = document.getElementById('avatar').clientWidth;
    //console.log("width: " + elWidth);
    const app = new PIXI.Application({
      view: document.getElementById('l2dcanvas'),
      autoStart: true,
      width: elWidth,
      backgroundAlpha: 0,
      resizeTo: div,
    })
    
    let jsonPath = props.path;
    //console.log('path: ' + jsonPath);
    Live2DModel.from(jsonPath, { autoInteract: true,  idleMotionGroup: 'idle' }).then((model) => {
      app.stage.addChild(model)
      model.anchor.set(0.5, 0.5)
      model.position.set(200, 250)
      model.scale.set(0.3, 0.3)
      
      model.motion("motion");

      window.onresize = function (event){    
        var w = document.getElementById('avatar').clientWidth; 
        var h = document.getElementById('l2dcanvas').clientHeight;    
       // var h = window.innerHeight;    //this part resizes the canvas but keeps ratio the same    
      app.view.style.width = w + "px";    
     // app.view.style.height = h + "px";    //this part adjusts the ratio:    
      app.resize(w,h);
    }


    })
  }, [])


  return <canvas id="l2dcanvas" style={{marginTop: '-50px'}}/>
}

export default Live2DAvatarStandard
